import { createFileRoute } from '@tanstack/react-router';

import { WalletPointsPage } from './WalletPointsPage';

export const Route = createFileRoute('/_protected/_consumer/wallet/points/')({
  component: WalletPointsPage,
});
